import React from 'react';
import styles from "fantastic/components/hoc/styles";
import { compose } from "redux";

const Divider = ({style}) => {
  return(
    <hr style={style}/>
  )
};

export default compose(
  styles("background")
)(Divider);
